<template>
  <div class="flex-none text-right mdsm:hidden">
    <span>from</span>
    <span
      v-if="supplierInfo && supplierInfo.price_per_night"
      class="font-bry font-bold fs-32"
      id="yatchPriceValue"
    >
      <currency-context>
        <template v-slot="{ convert }">
          <span v-text="convert(supplierInfo.price_per_night)"></span>
        </template>
      </currency-context>
    </span>
    <span> /night</span>
    <br />
    <span class="text-black-light-5" v-text="guest" />
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import get from "lodash/get";
import formatMoney from "../../helpers/formatMoney";
import CurrencyContext from "../../components/core/CurrencyContext";
import { convertPrice } from "../../helpers";

export default {
  components: {
    CurrencyContext,
  },
  data() {
    return {
      currency: window.topNavStore.state.currency,
    };
  },
  mounted() {
    window.addEventListener("onCurrencyChanged", (e) => {
      this.currency = e.detail.currency;
    });
  },
  computed: {
    ...mapState(["supplier"]),
    ...mapGetters(["cabinLabel", "guestLabel"]),
    supplierInfo() {
      return get(this.supplier, "supplier", []);
    },
    guest() {
      return (
        this.supplierInfo.number_of_cabins +
        " " +
        this.cabinLabel +
        ", up to " +
        this.supplierInfo.max_occupancy +
        " " +
        this.guestLabel
      );
    },
  },
  methods: {
    loadPriceByCurrency (supplierInfo = this.supplierInfo, currency = this.currency) {
      const yatchNavPrice = $("#yatchNavPrice");
        const yatchFooterPrice = $("#yachtFooterPrice");
        const price = convertPrice(
          currency.code,
          supplierInfo.price_per_night
        );
        const money = `${currency.symbol}${price}`;

        yatchNavPrice.html(money);
        yatchFooterPrice.html(money);
    }
  },
  watch: {
    supplierInfo(supplierInfo) {
      try {
        this.loadPriceByCurrency(supplierInfo)
      } catch (error) {}
    },
    currency: {
      handler(value) {
        this.loadPriceByCurrency(this.supplierInfo, value)
      }
    },
  },
};
</script>
